_collow.components.LearningGoalsStepPage = class LearningGoalsStepPage extends _collow.components.Base {
    root;
    elements;
    params;
    learningGoalOptions;
    optionsContainer;
    currentStepNumber;
    originalOptionText;
  
    constructor(root, elements, params) {
      super();
  
      this.root = root;
      this.elements = elements;
      this.params = params;
      this.optionsContainer = document.querySelector(".learning-goals-options-container")
      this.learningGoalOptions = []

      this.listen(document, "_save-steps-info", this.saveStespInfo)
      document.querySelector(".learning-goals-add-button").addEventListener("click", this.openInputToCreateOption)
      this.listen(document, "_init-learning-goals-step", this.initLearningGoalsStep);
    }

    toggleLoadingSpinner = (action, index) => {
      const spinner = document.getElementById("spinner");
      
      if(action === "show generate") {
        spinner.style.display = "flex";
        document.querySelector(".learning-goals-add-button").style.display = "none"
      } else if (action === "hide generate") {
        spinner.style.display = "none";
        document.querySelector(".learning-goals-add-button").style.display = "block"
      } else if (action === "show regenerate") {
        document.querySelectorAll(".learningGoal")[index].innerHTML = '<div style="display: flex;" id="spinner"><div class="loader"><i class="fa-solid fa-spinner fa-lg"></i></div></div>'
      } 
    }
    
    getLearningGoalOptions = async (inputData) => {
      if(inputData) {
        try {
          this.toggleLoadingSpinner("show generate")

          const formdata = new FormData();
          formdata.append("topic", inputData[0].data);
          formdata.append("level", inputData[2].data);
          formdata.append("sector", inputData[1].data);
          formdata.append("duration", inputData[3].data);
      
          const response = await fetch(this.params.path + "/eduai/generate_learning_goals", {
            method: "POST",
            headers: {
              Authorization: localStorage.getItem("token"),
            },
            body: formdata,
          });
      
          if (!response.ok) {
            throw new Error(`Erro na requisição: ${response.status}`);
          }
          const data = await response.json();
          this.learningGoalOptions = [...data.learning_goals]
          
          this.addLearningGoaltoBody();
  
          this.currentStepNumber = document.querySelector(`.content-section[active="true"]`).getAttribute("step-number").split("-")[1];
          this.toogleNextBtn()
        } catch (error) {
          console.error("Erro ao buscar Learning Goals:", error);
        } finally {
          this.toggleLoadingSpinner("hide generate")
        }

      }
    }

    initLearningGoalsStep = async ({detail}) => {
      const {data} = detail
      this.stepsInfo = data

      if(detail.fresh) {
        this.learningGoalOptions = []
        this.saveStespInfo({detail: {subject: data[0].data}})
        this.dispatch(this.root, "_reset-changed-flags", {data: this.stepsInfo});
        this.optionsContainer.innerHTML = ""
      }
      if(this.learningGoalOptions.length > 0) return

      this.getLearningGoalOptions(data)
    }

    toogleNextBtn = () => {
      if(this.learningGoalOptions.length < 2) {
        this.dispatch(this.root, "_toogle-next-btn", {step: this.currentStepNumber, completed: false, data: "null"});
      } else {
        this.dispatch(this.root, "_toogle-next-btn", {step: this.currentStepNumber, completed: true, data: this.learningGoalOptions});
      }
    }

    saveStespInfo = ({detail}) => {
      const { subject } = detail
      document.querySelector(".step-learning-goals-container span").textContent = subject
    }

    createNewLearningGoal = (text, index) => {
      return `<div class="learning-goals-option" >
        <span>${index+1}</span> <p class="learningGoal" data-option=${index}>${text}</p>
        <div class="icons-container icons-default" >
          <i class="fa-solid fa-arrow-rotate-left"></i>
          <i class="fa-solid fa-pencil"></i>
          <i class="fa-solid fa-trash" style="color: #ff0000;"></i>
        </div>
        <div class="icons-container icons-edit" >
          <i class="fa-solid fa-floppy-disk"></i>
          <i class="fa-solid fa-x fa-xs"></i>
        </div>
      </div>`
    }

    addLearningGoaltoBody = () => {
      this.optionsContainer.innerHTML = ""
      this.learningGoalOptions.forEach((option, index) => {
        this.optionsContainer.innerHTML += this.createNewLearningGoal(option, index)
      })
      this.handleEvents()
    }

    openInputToCreateOption = () => {
      this.handleTrashIcon("disable") 

      const newLearningGoalHTML = `<div class="learning-goals-option" >
        <textarea class="learningGoal"></textarea></p>
        <div class="icons-container icons-default" style="display: none;">
          <i class="fa-solid fa-arrow-rotate-left" style="color: #7c3ca5;"></i>
          <i class="fa-solid fa-pencil" style="color: #7c3ca5;"></i>
          <i class="fa-solid fa-trash" style="color: #ff0000;"></i>
        </div>
        <div class="icons-container icons-edit" style="display: flex;" >
            <i class="fa-solid fa-arrow-rotate-left generate_new" style="color: #7c3ca5;"></i>
          <i class="fa-solid fa-floppy-disk" style="color: #7c3ca5;"></i>
          <i class="fa-solid fa-x fa-xs" style="color: #7c3ca5;"></i>
        </div>
      </div>`
      this.optionsContainer.innerHTML += newLearningGoalHTML;

      const textarea = this.optionsContainer.querySelector("textarea")
      textarea.focus();
      textarea.addEventListener("blur", (event) => {
        event.preventDefault(); 
        textarea.focus();       
      });


      this.optionsContainer.lastElementChild.querySelector(".generate_new").addEventListener("click", (e) => this.handleOption(e, "getNewLearningGoalInput"))
      this.optionsContainer.lastElementChild.querySelector(".fa-floppy-disk").addEventListener("click", (e) => this.handleOption(e, "saveNewLearningGoal", textarea.value))
      this.optionsContainer.lastElementChild.querySelector(".fa-x").addEventListener("click", (e) => this.handleOption(e, "discardNewLearningGoal", this.optionsContainer.lastElementChild))
    }

    saveNewLearningGoal = (newLearningGoal) => {
      this.handleTrashIcon("enable") 

      this.learningGoalOptions = [...this.learningGoalOptions, newLearningGoal]
      this.addLearningGoaltoBody()
      this.updateLearningGoalOptions()
    }

    discardNewLearningGoal = (element) => {
      element.remove()
      this.handleEvents()
    }

    updateLearningGoalOptions = () => {
      this.learningGoalOptions = []
      const learningGoalsOptions = document.querySelectorAll(".learningGoal")
      learningGoalsOptions.forEach(option =>  {
        this.learningGoalOptions.push(option.textContent)
      })
      this.toogleNextBtn()
    }

    handleEvents = () => {
      const optionsQuantity = this.learningGoalOptions.length
      document.querySelectorAll(".icons-container .fa-pencil").forEach(pencil => pencil.addEventListener("click", (e) => this.handleOption(e, "edit")))
      document.querySelectorAll(".fa-floppy-disk").forEach(disk => disk.addEventListener('click', (e) => this.handleOption(e, "saveChanges")));
      document.querySelectorAll(".fa-x").forEach(x => x.addEventListener('click', (e) => this.handleOption(e, "discardChanges")));
      document.querySelectorAll(".fa-arrow-rotate-left").forEach(arrow => arrow.addEventListener('click', (e) => this.handleOption(e, "getNewLearningGoal")));

      const addLearningGoalBtn = document.querySelector(".learning-goals-add-button")
      
      optionsQuantity == 4 ? addLearningGoalBtn.setAttribute("disabled", "true") : addLearningGoalBtn.removeAttribute("disabled")
      optionsQuantity < 3 ? this.handleTrashIcon("disable") : this.handleTrashIcon("enable")
    }

    handleOption = (e, action, data) => {
      const optionClicked = e.target.closest(".learning-goals-option")
      
      switch (action) {
        case "edit":
          this.replaceToInput(optionClicked)
          break;
        case "delete":
          this.deleteOption(optionClicked)
          break;
        case "saveChanges":
          this.saveOptionChanges(e)
          break;
        case "discardChanges":
          this.discardOptionChanges(e)
          break;
        case "getNewLearningGoal":
          this.getNewLearningGoal(e)
          break;
        case "getNewLearningGoalInput":
          this.getNewLearningGoal(e, true)
          break;
        case "saveNewLearningGoal":
          this.saveNewLearningGoal(data)
          break;
        case "discardNewLearningGoal":
          this.discardNewLearningGoal(data)
          break;
        default:
          console.log("action not recognized");
      }
    }

    getNewLearningGoal = async (e, input=false) => {
      const parentArrow = e.target.parentElement
      const paragraphText = parentArrow.previousElementSibling.textContent
      const index = this.learningGoalOptions.findIndex(el => el === paragraphText)
      window.el = e.target

        try {
          if (!input) this.toggleLoadingSpinner("show regenerate", index)

          const formdata = new FormData();
          formdata.append("topic", this.stepsInfo[0].data);
          formdata.append("level", this.stepsInfo[2].data);
          formdata.append("sector", this.stepsInfo[1].data);
          formdata.append("duration", this.stepsInfo[3].data);
          this.learningGoalOptions.forEach(item => formdata.append("existing_learning_goals", item))
          formdata.append("goal_index", input ? this.learningGoalOptions.length - 1 :index);
      
          const response = await fetch(this.params.path + "/eduai/regenerate_learning_goal", {
            method: "POST",
            headers: {
              Authorization: localStorage.getItem("token"),
            },
            body: formdata,
          });
      
          if (!response.ok) {
            throw new Error(`Erro na requisição: ${response.status}`);
          }
          const data = await response.json();
          if (input) {
            e.target.parentElement.closest('.learning-goals-option').querySelector('textarea').value = data.learning_goal
          } else {
            this.learningGoalOptions[index] = data.learning_goal
            this.addLearningGoaltoBody();
          }

        } catch (error) {
          console.error("Erro ao buscar Learning Goals:", error);
        } finally {
          if (!input) this.toggleLoadingSpinner("hide regenerate", index)
        }
    }

    handleTrashIcon = (action) => {
      const trashIcons = document.querySelectorAll(".fa-trash")
      if(action === "enable") {
        trashIcons.forEach(icon => {
          icon.addEventListener("click", (e) => this.handleOption(e, "delete"))
          icon.style.color = "#FF0000"
        }) 
      } else if(action === "disable"){
        trashIcons.forEach(icon => {
          icon.removeEventListener("click", this.handleOption)
          icon.style.color = "#FFCCCC"
        }) 
      }
    }

    replaceToInput = (optionClicked) => {
      this.handleTrashIcon("disable") 

      const paragraph = optionClicked.querySelector(".learningGoal")
      const textarea = document.createElement('textarea');
      
      textarea.value = paragraph.textContent;
      this.originalOptionText =  paragraph.textContent;
      textarea.classList.add('learningGoal')
      paragraph.replaceWith(textarea);

      textarea.focus();
      textarea.addEventListener("blur", (event) => {
        event.preventDefault();      
      });

      optionClicked.querySelector(".icons-edit").style.display = "flex"
      optionClicked.querySelector(".icons-default").style.display = "none"
    }

    deleteOption = (option) => {
      option.remove()
      this.updateLearningGoalOptions()
      this.addLearningGoaltoBody()
    }

    saveOptionChanges = (e) => {
      this.handleTrashIcon("enable") 

      const optionClicked = e.target.closest(".learning-goals-option")
      this.revertToParagraph("save",optionClicked);

      optionClicked.querySelector(".icons-edit").style.display = "none"
      optionClicked.querySelector(".icons-default").style.display = "flex"
    }

    discardOptionChanges = (e) => {
      this.handleTrashIcon("enable") 

      const optionClicked = e.target.closest(".learning-goals-option")
      this.revertToParagraph("discard", optionClicked);

      optionClicked.querySelector(".icons-edit").style.display = "none"
      optionClicked.querySelector(".icons-default").style.display = "flex"
    }

    revertToParagraph = (action, optionClicked) => {
      const textarea = optionClicked.querySelector('textarea');
      const paragraph = document.createElement('p');
      paragraph.classList.add('learningGoal')

      if(action === "discard") {
        paragraph.textContent = this.originalOptionText
      } else if(action === "save") {
        paragraph.textContent = textarea.value;
      }

      textarea.replaceWith(paragraph);
      this.updateLearningGoalOptions()
  }
};
  
   
  
  
  
  
  
  